import React from 'react'

import './BusinessEventIcon.scss'

interface BusinessEventIconProps {
  className?: string
}

export const BusinessEventIcon: React.FC<BusinessEventIconProps> = ({ className = '' }) => {
  return (
    <div className={`business-event-icon-wrapper d-flex align-items-center justify-content-center ${className}`}>
      <i className='bi bi-lightning-charge' />
    </div>
  )
}
